import { Box, Stack, Title } from '@mantine/core'

import type { HelpSubSection } from '@/configs/helpContent.types'

import { CollapsibleHelpSection } from './CollapsibleHelpSection'
import { HelpEntryAnswer } from './HelpEntryAnswer'

type HelpSubSectionRendererProps = {
  subSection: HelpSubSection
  level: number
}

export function HelpSubSectionRenderer({ subSection, level }: HelpSubSectionRendererProps) {
  // Determine the title order based on the nesting level
  const titleOrder = Math.min(6, 5 + level) as 1 | 2 | 3 | 4 | 5 | 6

  return (
    <Stack gap="md">
      {subSection.title && (
        <Title order={titleOrder} c={level > 1 ? 'dimmed' : undefined}>
          {subSection.title}
        </Title>
      )}

      {/* Render entries if they exist */}
      {subSection.entries?.map(entry => (
        <CollapsibleHelpSection
          key={entry.question}
          title={entry.question}
          ContentElement={<HelpEntryAnswer entry={entry} />}
          defaultCollapsed
        />
      ))}

      {/* Recursively render nested subsections if they exist */}
      {subSection.subSections?.map((nestedSubSection, index) => (
        <Box key={index} ml={level > 1 ? 'md' : 0}>
          <HelpSubSectionRenderer subSection={nestedSubSection} level={level + 1} />
        </Box>
      ))}
    </Stack>
  )
}
